module.exports = __webpack_public_path__ + "img/fi-rr-caret-down.dd5711fd.svg";